<template>
    <el-card class="box-card">
        <div class="content-wrapper">
            <div class="icon-section">
                <!-- 使用Element Plus图标 -->
                <el-icon class="icon">
                    <!-- <img src="Tencent_EN.svg"> -->
                    <img :src="image_path" :style="image_style">
                </el-icon>
            </div>
            <!-- 图标右侧的三行内容 -->
            <div class="upper-text">
                <!-- <div class="text-row title">Infrastructure Developer</div>
                <div class="text-row company">Tencent Weixin Group (WXG)</div>
                <div class="text-row time">2024.1 - 2024.3</div> -->
                <div class="text-row title">{{ title }}</div>
                <div class="text-row company">{{ company }}</div>
                <div class="text-row time">{{ time }}</div>
            </div>
            <!-- 图标下方的若干行内容 -->
            <div class="additional-content">
                <!-- <div>Storage, Leveldb, Libco</div> -->
                <div v-for="entry in  contents " :key="entry.content" :style="{fontSize: '1.04vw'}">{{ entry.content }}</div>
                <!-- 可以继续添加更多内容 -->
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'VueCard',
    // data() {
    //     return {
    //         title: 'Infrastructure Developer',
    //         company: 'Tencent WXG',
    //         time: '2024.1 - 2024.3',
    //         contents: [{ content: 'Storage, Leveldb, Libco' }],
    //         image_path: 'images/Tencent_EN.svg'
    //     };
    // }
}
</script>
  
<script setup>
import { ElCard, ElIcon } from 'element-plus';
import { defineProps } from 'vue';
defineProps({
    title: String,
    company: String,
    time: String,
    image_path: String,
    contents: Array,
    image_style: Object
});
</script>
  
<style scoped>
.box-card {
    width: 100%;
    min-width: 32.5vw;
    box-shadow: 0 0.26vw 0.39vw rgba(0, 0, 0, 0.1);
    border-radius: 0.52vw;
    overflow: hidden;
    position: relative;
    /* 相对定位作为图标绝对定位的参照 */
    padding: 0.13vw;
    /* 给内容区域添加内边距 */
    padding-left: 0.65vw;
    /* 确保左侧有足够空间放置图标 */
    margin-bottom: 0.65vw;
}

.content-wrapper {
    position: relative;
    /* 相对定位 */
}

.icon-section {
    position: absolute;
    /* 绝对定位 */
    top: 0.13vw;
    /* 与内容区域上边距 */
    left: 0.13vw;
    /* 与内容区域左边距 */
}

.icon {
    font-size: 3.9vw;
    color: #409EFF;
}

.upper-text {
    margin-left: 5.85vw;
    text-align: left;
    margin-bottom: 1.3vw;
    /* 与附加内容的间隔 */
}

.text-row {
    margin-bottom: 0.325vw;
}

.title {
    font-size: 1.3vw;
    font-weight: bold;
    color: #333;
}

.company {
    font-size: 1.04vw;
    color: #666;
}

.time {
    font-size: 0.9115vw;
    color: #999;
}

.additional-content {
    padding-left: 1.3vw;
    /* 调整以与图标中心对齐 */
    border-left: 0.13vw solid #409EFF;
    /* 左侧边线 */
    margin-left: 0.95vw;
    /* 与图标左边距相同 */
}

.additional-content div {
    text-align: left;
    padding: 0.26vw 0;
}
</style>